import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchDeletePortfolioCompany,
  fetchDeletePortfolioTeam,
  fetchingPortfolioCompanyJson,
  fetchPortfolioCompanyDetails,
  fetchPortfolioTeamDetails,
  updatingPortfolioCompany,
  updatingPortfolioTeam,
} from '../Slice/FundActions';

export const getPorfolioCompany = createAsyncThunk(
  'fundManager/getPortfolioCompany',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } =
        await fetchPortfolioCompanyDetails(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getPortfolioTeams = createAsyncThunk(
  'funds/getPortfolioTeams',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchPortfolioTeamDetails(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePortfolioCompany = createAsyncThunk(
  'portfolioCompany/updateDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await updatingPortfolioCompany(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePortfolioTeam = createAsyncThunk(
  'PortfolioTeam/updateDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await updatingPortfolioTeam(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePortfolioCompany = createAsyncThunk(
  'portfolioCompany/deleteDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchDeletePortfolioCompany(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePortfolioTeam = createAsyncThunk(
  'portfolioTeam/deleteDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchDeletePortfolioTeam(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePortfolioCompanyJson = createAsyncThunk(
  'portfolioCompany/updateDetailsJson',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } =
        await fetchingPortfolioCompanyJson(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
